import React from 'react';
import { RouteComponentProps } from "react-router";
import SessionDetail from "./SessionDetail";
import Participants from "./Participants";

interface MatchParams {
    id: string,
}

interface MatchProps extends RouteComponentProps<MatchParams>{
    params: { id },
}

interface IProps {
    match: MatchProps,
}


class SessionPage extends React.Component <IProps> {
    render(): React.ReactNode {
        const { match } = this.props;
        const { id } = match.params;
        return (
            <div key={id}>
                <SessionDetail id={id} />
                <Participants id={id} />
            </div>
        )
    }

}
export default SessionPage;